import { createResourceKeys } from "@/lib/resource-context";
import type { AuditLogsFilters } from "../search";

type ScopeParams = {
  organizationId: string;
  projectId: string;
};

type ListKeyParams = ScopeParams & {
  filters: AuditLogsFilters;
  limit: number;
  offset: number;
};

const resourceKeys = createResourceKeys("audit_logs");

/**
 * Built on the shared factory so the keys sit under the `resources` namespace
 * that prefix-based invalidation walks.
 *
 * Filters and pagination are appended to the list key because each one changes
 * the request the coordinator sees.
 */
export const auditLogsKeys = {
  ...resourceKeys,
  list: ({
    organizationId,
    projectId,
    filters,
    limit,
    offset,
  }: ListKeyParams) =>
    [
      ...resourceKeys.list({ scope: { organizationId, projectId } }),
      { filters, limit, offset },
    ] as const,
  filterOptions: ({
    organizationId,
    projectId,
    filters,
  }: ScopeParams & { filters: AuditLogsFilters }) =>
    [
      ...resourceKeys.list({ scope: { organizationId, projectId } }),
      "filter-options",
      { filters },
    ] as const,
  newerHead: ({
    organizationId,
    projectId,
    filters,
    limit,
  }: Omit<ListKeyParams, "offset">) =>
    [
      ...resourceKeys.list({ scope: { organizationId, projectId } }),
      "newer-head",
      { filters, limit },
    ] as const,
};
